import type { Offer, Order, PaymentMethod } from '../../types/checkout';
import type { MediaProduct } from '../../types/media';

import { createStore } from './utils';

type CheckoutStore = {
  requestedMediaProducts: MediaProduct[];
  offers: Offer[];
  switchSubscriptionOffers: Offer[]; // @todo: merge with offers?
  selectedOffer: Offer | null;
  defaultOfferId: string | null;
  order: Order | null;
  paymentMethods: PaymentMethod[] | null;
  setRequestedMediaProducts: (requestedMediaProducts: MediaProduct[]) => void;
  setOrder: (order: Order | null) => void;
  setPaymentMethods: (paymentMethods: PaymentMethod[] | null) => void;
};

export const useCheckoutStore = createStore<CheckoutStore>('CheckoutStore', (set) => ({
  requestedMediaProducts: [],
  offers: [],
  switchSubscriptionOffers: [],
  selectedOffer: null,
  defaultOfferId: null,
  order: null,
  paymentMethods: null,
  setRequestedMediaProducts: (requestedMediaProducts) => set({ requestedMediaProducts }),
  setOrder: (order) => set({ order }),
  setPaymentMethods: (paymentMethods) => set({ paymentMethods }),
}));
